import { Linkedin, ArrowUpRight, Dribbble } from "lucide-react";
import { CONTACT } from "../lib/data";
import { scrollToId } from "./Reveal";

export const Footer = () => {
  return (
    <footer className="pt-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="glass rounded-[2.5rem] p-10 lg:p-16 mb-8">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brand mb-6">Let&rsquo;s work together</p>
              <p className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink max-w-2xl leading-[1.05]">
                Have a project <span className="text-gradient">in mind?</span>
              </p>
              <button onClick={() => scrollToId("contact")} className="mt-8 inline-flex items-center gap-2 rounded-full btn-gradient px-7 py-4 text-base font-semibold shadow-xl shadow-brand/25 hover:opacity-90 transition-opacity" data-testid="footer-cta">
                Start a project <ArrowUpRight className="w-5 h-5" />
              </button>
            </div>
            <div className="flex flex-col gap-3">
              <a href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-ink-soft hover:text-brand transition-colors" data-testid="footer-linkedin">
                <Linkedin className="w-5 h-5" /> {CONTACT.linkedinLabel}
              </a>
              <a href={CONTACT.behance} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-ink-soft hover:text-brand transition-colors" data-testid="footer-behance">
                <Dribbble className="w-5 h-5" /> {CONTACT.behanceLabel}
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 py-8 text-sm text-ink-soft border-t border-line">
          <p className="font-display font-extrabold text-lg text-ink">Ricky<span className="text-gradient">Sokhi</span></p>
          <p className="font-light">© {new Date().getFullYear()} — UI/UX Designer & Front-end Developer. All rights reserved.</p>
          <button onClick={() => scrollToId("hero")} className="hover:text-brand transition-colors font-light" data-testid="footer-back-to-top">Back to top ↑</button>
        </div>
      </div>
    </footer>
  );
};
